import React from 'react';
import {Form} from "react-bootstrap";
import PropTypes from "prop-types";

function Year(props) {
    const maxYear = ((new Date()).getFullYear() + 49).toString().slice(0, -1)
    props.elementProps.onKeyPress = function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            return e.target.blur()
        }
        if (e.key === 'Backspace' || e.keyCode === 8) {
            return
        }
        let orig = e.target.value
        const charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
        const charStr = String.fromCharCode(charCode);
        if (!(/\d/.test(charStr))) {
            e.preventDefault()
            return false
        }
        let temp = orig + '' + charStr
        if (temp.length > 4) {
            e.preventDefault()
            return false
        }
        // if the cursor is at the end of the field, format to a date like string
        if (e.target.value.length === e.target.selectionStart && e.target.selectionEnd - e.target.selectionStart === 0) {

            if ((temp.length === 1 && ![1, 2].includes(parseInt(temp))) ||
                (temp.length === 2 && ![19, 20].includes(parseInt(temp))) ||
                (temp.length === 3 && (parseInt(temp) < 195 || parseInt(temp) > maxYear))) {
                e.preventDefault()
                temp = temp.slice(0, -1)
                e.target.value = temp
                return false
            }

        }
    }

    props.elementProps.onBlur = function (e) {
        props.setAnswer(parseInt(e.target.value))
    }
    return (<Form.Control type="tel" {...props.elementProps} />)
}
Year.propTypes = {
    defaultValue: PropTypes.number,
    setAnswer: PropTypes.func,
    onFocus: PropTypes.func,
    rightElement: PropTypes.element,
};
export default Year;